import React from 'react'

const PaymentPolicy = () => {
    return (
        <div>
            <h1>Условия оплаты</h1>
            <p>Сайт <strong>HajjTravel.kz</strong> предоставляет возможность онлайн-оплаты туров и других услуг, связанных с организацией паломничества.</p>
            <h3>1. Способы оплаты</h3>
            <p>Мы принимаем:</p>
            <ul>
                <li>
                    <p>Банковские карты (Visa, MasterCard)</p>
                </li>                  
                <li>
                    <p>Kaspi.kz (через QR и Kaspi Gold)</p>
                </li>              
            </ul>
            <h3>2. Валюта расчетов</h3>
            <p>Все цены на сайте указаны в тенге (KZT). Оплата также принимается в тенге.</p>
            <h3>3. Безопасность платежей</h3>
            <p>Онлайн-платежи обрабатываются через защищённые платёжные шлюзы, сертифицированные по стандартам PCI DSS. Мы не храним данные ваших карт.</p>
            <h3>4. Подтверждение оплаты</h3>
            <p>После успешной оплаты клиент получает электронное подтверждение на указанный e-mail или через WhatsApp.</p>
        </div>
    )
}

export default PaymentPolicy;